import imageCompression from 'browser-image-compression'

const MAX_SIZE_MB = 5
const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024

const ATTEMPTS = [
  { maxWidthOrHeight: 1920, initialQuality: 0.9 },
  { maxWidthOrHeight: 1280, initialQuality: 0.7 },
  { maxWidthOrHeight: 960, initialQuality: 0.5 },
  { maxWidthOrHeight: 720, initialQuality: 0.3 },
]

export async function compressImageFile(file: File): Promise<File> {
  if (file.size <= MAX_SIZE_BYTES) return file

  if (!file.type.startsWith('image/')) {
    throw new Error(
      `File "${file.name}" exceeds 5MB limit (${(file.size / 1024 / 1024).toFixed(2)}MB).`
    )
  }

  let best: File | null = null
  for (const a of ATTEMPTS) {
    const compressed = await imageCompression(file, {
      maxSizeMB: MAX_SIZE_MB,
      maxWidthOrHeight: a.maxWidthOrHeight,
      useWebWorker: true,
      fileType: file.type,
      initialQuality: a.initialQuality,
    })
    if (compressed.size <= MAX_SIZE_BYTES) return compressed
    if (!best || compressed.size < best.size) best = compressed
  }
  if (best && best.size <= MAX_SIZE_BYTES) return best
  throw new Error(`File "${file.name}" exceeds 5MB limit even after compression.`)
}
